import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function getSkillTypeDescriptions({ activityId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Activity/GetSkillTypeDescriptions',
    params: { ActivityId: activityId },
  });
  return data;
}

async function addSkill({ activityCVId, level, skillTypeId, otherSkillType }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/AddSkill',
    data: sanitizePostData({
      activityCVId,
      level,
      skillTypeId,
      otherSkillType,
    }),
    generalErrorsOnly: true,
  });
  return data;
}

async function updateSkill({ skillId, level, skillTypeId, otherSkillType }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/UpdateSkill',
    data: sanitizePostData({ skillId, level, skillTypeId, otherSkillType }),
    generalErrorsOnly: true,
  });
  return data;
}

async function removeSkill({ skillId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/RemoveSkill',
    data: sanitizePostData({ skillId }),
  });
  return data;
}

export { getSkillTypeDescriptions, addSkill, updateSkill, removeSkill };
